import { render, staticRenderFns } from "./notice_channel.vue?vue&type=template&id=47deea44&scoped=true"
import script from "./notice_channel.vue?vue&type=script&lang=js"
export * from "./notice_channel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47deea44",
  null
  
)

export default component.exports